import { render, staticRenderFns } from "./MercyRulesManager.vue?vue&type=template&id=3307f798&scoped=true"
import script from "./MercyRulesManager.vue?vue&type=script&lang=js"
export * from "./MercyRulesManager.vue?vue&type=script&lang=js"
import style0 from "./MercyRulesManager.vue?vue&type=style&index=0&id=3307f798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3307f798",
  null
  
)

export default component.exports